export default __webpack_public_path__ + "static/media/Group9263.6a96a3aa.svg";